import { render } from "./LongList.vue?vue&type=template&id=aba67bd6&scoped=true"
import script from "./LongList.vue?vue&type=script&lang=js"
export * from "./LongList.vue?vue&type=script&lang=js"

import "./LongList.vue?vue&type=style&index=0&id=aba67bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba67bd6"]])

export default __exports__